var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckSquareOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "v0gk5akpwa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.535-3.41L1.674-7.762.326-6.285 6.658-.59l8.951-9.733-1.472-1.354z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-744 -2391)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#6728ff",
    rx: 4,
    transform: "translate(744 2391)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v0gk5akpwa)",
    transform: "translate(747.075 2408.177)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-4.674-16.677h25.283V4.41H-4.674z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckSquareOn);
export default __webpack_public_path__ + "static/media/ic_check_square_on.8bc49121ea994f06c7ce37e9cbd0993d.svg";
export { ForwardRef as ReactComponent };